import { createSlice } from "@reduxjs/toolkit";
import { getAllCancelledCount, getAllCount, getAllIssuedCount, getAllPendingCount, getAllVerifiedCount, getCertificateGraphCreation } from "./dashboardService";

/* -------------------- Status Enum -------------------- */

export const STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
};

/* -------------------- Initial State -------------------- */

const initialState = {

  certificatePendingCount: {
    status: STATUS.IDLE,
    error: null,
    data: [],
  },

   certificateVerifiedCount: {
    status: STATUS.IDLE,
    error: null,
    data: [],
  },

   certificateIssuedCount: {
    status: STATUS.IDLE,
    error: null,
    data: [],
  },

   certificateCancelledCount: {
    status: STATUS.IDLE,
    error: null,
    data: [],
  },

  certificateGraphData: {
    status: STATUS.IDLE,
    error: null,
    data: [],
  },
};

/* -------------------- Slice -------------------- */

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    /* ---------- Create Certificate Type ---------- */
    builder
      .addCase(getAllPendingCount.pending, (state) => {
        state.certificatePendingCount.status = STATUS.LOADING;
        state.certificatePendingCount.error = null;
      })
      .addCase(getAllPendingCount.fulfilled, (state, action) => {
        state.certificatePendingCount.status = STATUS.SUCCEEDED;
        state.certificatePendingCount.data = action?.payload || [];
      })
      .addCase(getAllPendingCount.rejected, (state, action) => {
        state.certificatePendingCount.status = STATUS.FAILED;
        state.certificatePendingCount.error = action?.payload;
      });

       builder
      .addCase(getAllVerifiedCount.pending, (state) => {
        state.certificateVerifiedCount.status = STATUS.LOADING;
        state.certificateVerifiedCount.error = null;
      })
      .addCase(getAllVerifiedCount.fulfilled, (state, action) => {
        state.certificateVerifiedCount.status = STATUS.SUCCEEDED;
        state.certificateVerifiedCount.data = action?.payload || [];
      })
      .addCase(getAllVerifiedCount.rejected, (state, action) => {
        state.certificateVerifiedCount.status = STATUS.FAILED;
        state.certificateVerifiedCount.error = action?.payload;
      });

         builder
      .addCase(getAllIssuedCount.pending, (state) => {
        state.certificateIssuedCount.status = STATUS.LOADING;
        state.certificateIssuedCount.error = null;
      })
      .addCase(getAllIssuedCount.fulfilled, (state, action) => {
        state.certificateIssuedCount.status = STATUS.SUCCEEDED;
        state.certificateIssuedCount.data = action?.payload || [];
      })
      .addCase(getAllIssuedCount.rejected, (state, action) => {
        state.certificateIssuedCount.status = STATUS.FAILED;
        state.certificateIssuedCount.error = action?.payload;
      });

         builder
      .addCase(getAllCancelledCount.pending, (state) => {
        state.certificateCancelledCount.status = STATUS.LOADING;
        state.certificateCancelledCount.error = null;
      })
      .addCase(getAllCancelledCount.fulfilled, (state, action) => {
        state.certificateCancelledCount.status = STATUS.SUCCEEDED;
        state.certificateCancelledCount.data = action?.payload || [];
      })
      .addCase(getAllCancelledCount.rejected, (state, action) => {
        state.certificateCancelledCount.status = STATUS.FAILED;
        state.certificateCancelledCount.error = action?.payload;
      });

    builder
      .addCase(getCertificateGraphCreation.pending, (state) => {
        state.certificateGraphData.status = STATUS.LOADING;
        state.certificateGraphData.error = null;
      })
      .addCase(getCertificateGraphCreation.fulfilled, (state, action) => {
        state.certificateGraphData.status = STATUS.SUCCEEDED;
        state.certificateGraphData.data = action?.payload || [];
      })
      .addCase(getCertificateGraphCreation.rejected, (state, action) => {
        state.certificateGraphData.status = STATUS.FAILED;
        state.certificateGraphData.error = action.payload?.message;
      });
  },
});

/* -------------------- Selectors -------------------- */

export const selectPendingCertificateCount = (state) =>
  state.dashboard.certificatePendingCount;

export const selectVerifiedCertificateCount = (state) =>
  state.dashboard.certificateVerifiedCount;

export const selectIssuedCertificateCount = (state) =>
  state.dashboard.certificateIssuedCount;

export const selectCancelledCertificateCount = (state) =>
  state.dashboard.certificateCancelledCount;

export const selectCertificateGraphData = (state) =>
  state.dashboard.certificateGraphData;

export default dashboardSlice.reducer;
